import { formatDate, parseDate, parseIsoDate } from '@actr/utilities/src/date/format';

const REVIEW_DATE_FORMAT = 'dd.MM.yyyy';

export function getFormattedDate(value: string) {
  const parsedDate = parseDate(value, REVIEW_DATE_FORMAT);

  return formatDate(parsedDate, 'dd MMM yyyy').toLowerCase();
}

/** Дата вылета горящего предложения: день и сокращённый месяц */
export function formatOfferDate(value: string): string {
  const parsedDate = parseIsoDate(value);

  return formatDate(parsedDate, 'd MMM');
}
